import React from "react";
import { AlignLeft, GalleryHorizontalEnd } from "lucide-react";

import { Card, Segmented, Hint } from "./ui";

const TYPES = [
  {
    value: "STANDARD",
    label: "Standard",
    description: "A single message with header, body, footer and buttons.",
    icon: AlignLeft,
  },
  {
    value: "CAROUSEL",
    label: "Carousel",
    description: "Up to 10 swipeable cards, each with media and buttons.",
    icon: GalleryHorizontalEnd,
  },
];

const TemplateTypeCard = ({ value, onChange }) => {
  return (
    <Card>
      <Segmented
        options={TYPES}
        value={value.template_type}
        onChange={(template_type) => onChange({ template_type })}
      />
      <Hint>Carousels are available for Marketing templates only.</Hint>
    </Card>
  );
};

export default TemplateTypeCard;
